module.exports = __webpack_public_path__ + "img/3-2.83b2cdc2.png";